import {useCallback, useRef, useState} from 'react'
import {actions as usersActions, selectors as usersSelectors} from "../../../Ducks/users";
import {selectors as accountSelectors} from '../../../Ducks/account';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import GridElement from '../../Common/GridElement';
import {Button} from '@mui/material';
import {cloneDeep, isEmpty} from 'lodash';
import {getVisibleColumns, prepareFilterQuery, prepareSortQuery} from "../../Utils/gridUtils";
import {getUsers} from "../../../API/users";
import {updateUserSetting} from "../../../API/userSettings";
import {getUserSettings} from "../../Utils/constants";

const isDateColumn = (key) => {
    return (key === 'user_deactivated')
}

const UsersGrid = (props) => {
    const {navigate} = props;
    const {user, userMeta} = getUserSettings();
    const lastSortBy = user?.tableSettings?.users?.sortBy ? user.tableSettings.users.sortBy : null;

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [rowsCount, setRowsCount] = useState(0);
    const [filters, setFilters] = useState(() => {
        return user?.tableSettings?.users?.filters ? user.tableSettings.users.filters : [];
    });
    const [controlledPageIndex, setControlledPageIndex] = useState(0);
    const [cols, setCols] = useState(() => {
        let columns = userMeta.table_columns.users;
        let visibleColumns = user.tableSettings.users?.columns ? user.tableSettings.users?.columns : [];
        let invisibleColumns = columns.filter((column) => !visibleColumns.includes(column));
        columns = [...visibleColumns, ...invisibleColumns];

        return getVisibleColumns(columns, visibleColumns, isDateColumn);
    });

    const fetchIdRef = useRef(0);

    const fetchData = useCallback(({pageSize, pageIndex, sortBy, filters, columns}) => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,
        // even a server. But for this example, we'll just fake it.

        // Parse columns
        const _columns = columns.map((item) => item.column)

        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current

        // Set the loading state
        setLoading(true)

        // Check filter data
        let query = prepareFilterQuery(filters, columns);
        let sort = prepareSortQuery(sortBy, columns);

        getUsers({
            results: pageSize,
            columns: _columns,
            offset: pageIndex + 1,
            filter: query,
            sort: sort,
        }).then(users => {
            if (fetchId === fetchIdRef.current && users) {
                const _users = cloneDeep(users);
                const teams = users.data.related_objects["teams"]
                const countries = users.data.related_objects["countries"]

                if (!isEmpty(users.data.related_objects)) {
                    _users.data.main.forEach((user) => {
                        if (teams && !isEmpty(teams[user.team_id])) {
                            const _team_obj = cloneDeep(teams[user.team_id])
                            delete _team_obj["team_id"]
                            Object.assign(user, _team_obj);
                        }
                        if (countries && !isEmpty(countries[user.country_id])) {
                            const _country_obj = cloneDeep(countries[user.country_id])
                            delete _country_obj["country_id"]
                            Object.assign(user, _country_obj);
                        }
                    });
                }

                setData(_users.data.main);
                setPageCount(users.data.offset.highest_offset);
                setRowsCount(users.data.offset.rows_count);
                setLoading(false);

                const user = JSON.parse(localStorage.getItem("user"));
                updateUserSetting(user).then(() => {});
            }
        }).catch((_error) => {
            setLoading(false);
        });
    }, []);

    const resetFilters = useCallback(() => setFilters([]), [setFilters]);

    const handleRowClick = (row) => {
        navigate("/user/id/" + row.original.user_id);
    }

    return (
        <>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h2 className="page-title">Users</h2>
                <Button style={{textTransform: 'capitalize'}} variant="contained" color='primary'
                        onClick={() => navigate("/admin/user/add")}>Add Network Director</Button>
            </div>

            <GridElement
                columns={cols}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                rowsCount={rowsCount}
                handleRowClick={handleRowClick}
                initialSortBy="user_id"
                sortOrder='desc'
                hideSelection={true}
                showColumnsControl={true}
                showCsvDownloadControl={true}
                setColumns={setCols}
                table="users"
                lastSortBy={lastSortBy}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    isLoading: usersSelectors.isLoading(state),
    usersList: usersSelectors.usersList(state),
    user: accountSelectors.user(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getUsersList: usersActions.getUsersList
        },
        dispatch
    );

function WithNavigate(props) {
    let navigate = useNavigate();
    return <UsersGrid {...props} navigate={navigate}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigate);